import {
  Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectionStrategy, OnChanges, SimpleChanges, SimpleChange, ViewChild
  //, Renderer2, ElementRef
} from '@angular/core';
import {Column, DataTable, FilterOperator} from '../../base';
import {inputFormattedDate, getLastDate, formatDate, LastDateType} from '../../../common/utils';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Keys } from '../../../common';

@Component({
  selector: 'app-range-filter',
  templateUrl: 'range-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangeFilterComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() table: DataTable;
  @Input() rsltType: string;
  @Input() column: Column;
  @Input() isOpen: boolean;
  @Output() filterClose: EventEmitter<boolean> = new EventEmitter();
  @Output() filterOpen: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('filterInput', { static: false }) filterInput: any;
  @ViewChild('filterNewInput', { static: false }) filterNewInput: any;
  //https://stackoverflow.com/questions/38944725/how-to-get-dom-element-in-angular-2
  //https://stackoverflow.com/questions/46720611/how-to-use-angular4-to-set-focus-by-element-id
  //https://alligator.io/angular/using-renderer2/
  //@ViewChild('filterToInput', { static: false }) filterToInput: ElementRef;

  matchMode: string;
  value: any;
  valueTo: any;
  operators: any[];
  defaultMatchMode = FilterOperator.EQUALS;

  startHours = [];
  selectedStartHours = 0;
  endHours = [];
  selectedEndHours = 0;

  startMinutes = [];
  selectedStartMinutes = 0;
  endMinutes = [];
  selectedEndMinutes = 0;

  startSeconds = [];
  selectedStartSeconds = 0;
  endSeconds = [];
  selectedEndSeconds = 0;

  constructor(private commonFilterService: CommonFilterService) { };//, private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit() {
    //console.log('onInit' + this.column.isDateType)
    for (let h = 0; h < 24; h++) {
      this.startHours.push({ id: h, name: h < 10 ? '0' + h.toString() : h.toString() });
      this.endHours.push({ id: h, name: h < 10 ? '0' + h.toString() : h.toString() });
    }
    for (let mOrs = 0; mOrs < 60; mOrs++) {
      this.startMinutes.push({ id: mOrs, name: mOrs < 10 ? '0' + mOrs.toString() : mOrs.toString() });
      this.endMinutes.push({ id: mOrs, name: mOrs < 10 ? '0' + mOrs.toString() : mOrs.toString() });

      this.startSeconds.push({ id: mOrs, name: mOrs < 10 ? '0' + mOrs.toString() : mOrs.toString() });
      this.endSeconds.push({ id: mOrs, name: mOrs < 10 ? '0' + mOrs.toString() : mOrs.toString() });
    }

    this.operators = [
      {value: FilterOperator.EQUALS, text: this.table.messages.equals},
      {value: FilterOperator.NOT_EQUAL, text: this.table.messages.notEqual},
      {value: FilterOperator.GREATER_THAN, text: this.table.messages.greaterThan},
      {value: FilterOperator.GREATER_THAN_OR_EQUAL, text: this.table.messages.greaterThanOrEqual},
      {value: FilterOperator.LESS_THAN, text: this.table.messages.lessThan},
      {value: FilterOperator.LESS_THAN_OR_EQUAL, text: this.table.messages.lessThanOrEqual},
      {value: FilterOperator.IN_RANGE, text: this.table.messages.inRange},
      //{value: FilterOperator.IS_EMPTY, text: this.table.messages.isEmpty},
      //{value: FilterOperator.IS_NOT_EMPTY, text: this.table.messages.isNotEmpty},
    ];
    
  }

  inputDateToTextType() {
    if (this.filterInput) {
      if (this.filterInput.nativeElement.type == "datetime-local")
        this.filterInput.nativeElement.type = "text";

      //const elementTo = this.renderer.selectRootElement(this.filterToInput["nativeElement"]);
      //setTimeout(() => {
      //  if (elementTo.type == "datetime-local")
      //    elementTo.type = "text";
      //}, 0);

      //if (this.filterToInput && this.isRangeFilter) {
      //  if (this.filterToInput.nativeElement.type == "datetime-local")
      //    this.filterToInput.nativeElement.type = "text";
      //  //else if (this.filterToInput.nativeElement.type == "text")
      //  //  this.filterToInput.nativeElement.type = "datetime-local";
      //}
      ////else if (this.filterInput.nativeElement.type == "text")
      ////  this.filterInput.nativeElement.type = "datetime-local";
    }
  }
  ngAfterViewInit() {
    //console.log('onAfterView' + this.column.isDateType)
   //this.inputDateToTextType();    
   this.setFocus();
    //this.commonFilterService.GeneralFilter.subscribe(res => {
    //  this.table.dataFilter.filters = res;
    //  this.matchMode = this.table.dataFilter.getFilterMatchMode(this.column.name) || this.defaultMatchMode;
    //  this.value = this.table.dataFilter.getFilterValue(this.column.name);
    //  this.setFocus();
    //}); 
  }

  dontApply: boolean = false;
  ngOnChanges(): void {
    //console.log('OnChanges' + this.column.isDateType + ':' + this.filterInput)
    this.dontApply = this.column.isDateType ? false : true;
    this.matchMode = this.table.dataFilter.getFilterMatchMode(this.column.name) || this.defaultMatchMode;
    this.value = this.table.dataFilter.getFilterValue(this.column.name);
    this.valueTo = this.table.dataFilter.getFilterValueTo(this.column.name);
    this.setFocus();
  }

  get isValueFilter() {
    return !this.table.dataFilter.isNonValueFilter(this.matchMode);
  }

  get isRangeFilter() {
    return this.matchMode === FilterOperator.IN_RANGE;
  }

  saveFilter() {
    //console.log(this.valueTo);//08/25/2020 12:38:48  - 2020-08-13
    //console.log(this.matchMode)
    let finalValue = this.value;
    let finalValueTo = this.valueTo;
    let colName = this.column.name.toLowerCase();
    if (colName.indexOf('timestamp') != -1) {
      if (this.lastDateSelected === false) {//equals, range, etc but not last 10min, today, last year etc
        if (finalValue != 0) {
          let finalValues = finalValue.split('-');
          finalValue = finalValues[1] + '/' + finalValues[2] + '/' + finalValues[0] + ' '
            + (this.selectedStartHours < 10 ? ('0' + this.selectedStartHours) : this.selectedStartHours)
            + ':' + (this.selectedStartMinutes < 10 ? ('0' + this.selectedStartMinutes) : this.selectedStartMinutes)
            + ':' + (this.selectedStartSeconds < 10 ? ('0' + this.selectedStartSeconds) : this.selectedStartSeconds);
        }
        if (this.matchMode === FilterOperator.IN_RANGE) {//valueTo only when in range selected
          if (finalValueTo != null) {
            let finalValuesTo = finalValueTo.split('-');
            finalValueTo = finalValuesTo[1] + '/' + finalValuesTo[2] + '/' + finalValuesTo[0] + ' '
              + (this.selectedEndHours < 10 ? ('0' + this.selectedEndHours) : this.selectedEndHours)
              + ':' + (this.selectedEndMinutes < 10 ? ('0' + this.selectedEndMinutes) : this.selectedEndMinutes)
              + ':' + (this.selectedEndSeconds < 10 ? ('0' + this.selectedEndSeconds) : this.selectedEndSeconds);
          }
        }
      }
    }
    if (colName.indexOf('timestamp') != -1
      || colName.indexOf('gps') != -1)
      this.rsltType = "";

    if (colName == 'vqt_timestamp') 
      this.rsltType = "pesq|polqa";
    else if (colName == 'start_timestamp') 
      this.rsltType = "nettest|mobileinfo|vac";
    else if (colName == 'battery_level')
      this.rsltType = "nettest|mobileinfo";
    else if (colName == 'rssi' && this.rsltType != 'pesq' && this.rsltType != 'polqa')
      this.rsltType = "nettest|mobileinfo";

    //console.log(finalValue)
    //console.log(finalValueTo)
    this.table.dataFilter.setFilter(finalValue, this.column.name, this.matchMode, finalValueTo, this.column.dataType, this.rsltType, this.column.title);
    this.table.events.onFilter();
  }

  setFocus() {

    if (this.filterInput && this.isValueFilter) {
      setTimeout(() => {
        this.filterInput.nativeElement.focus();
      }, 1);
    }

    //setTimeout(() => {
    //  this.filterNewInput.nativeElement.focus();
    //}, 1);
  }

  onModeChange() {
    //console.log(this.isValueFilter + "::" + this.value)

    if (!this.isValueFilter) {
      //console.log("Empty/NotEmpty")
      this.value = 0;
      this.valueTo = null;
      this.saveFilter();
      this.filterClose.emit(true);
    } else if (this.value === 0) {
      this.value = null;
    }
    this.setFocus();
  }

  lastDateSelected = false;
  lastDate(name: LastDateType, messageRange: string) {
    this.lastDateSelected = true;
    //this.matchMode = FilterOperator.GREATER_THAN_OR_EQUAL;
    this.matchMode = FilterOperator.IN_RANGE;
    //this.commonFilterService.setDatesRangeProperties(name);

    let rangeInfo: any = {
      RangeType : name,
      RangeSelected: messageRange,
    }
    //console.log(rangeInfo)
    this.commonFilterService.setRangeFilterData(rangeInfo);

    let dbTz = -500;
    this.commonFilterService.DB_TZ.subscribe(res => {
      dbTz = res;
    });
    //console.log(dbTz)

    let dbAndBrHrs = -500;
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      dbAndBrHrs = res;
    });
    this.value = getLastDate(name, dbTz, dbAndBrHrs);
    let dt: Date = new Date();
    if (name === 'yesterday') {
      dt = new Date(Date.now() + -1 * 24 * 3600 * 1000);
      dt.setHours(23);
      dt.setMinutes(59);
      dt.setSeconds(59);
    }
    this.valueTo = formatDate(dt, dbTz, dbAndBrHrs);
    //console.log(this.value);
    this.saveFilter();
    this.lastDateSelected = false;
    this.filterClose.emit(true);
  }

  onClickOk() {
    this.saveFilter();
    this.filterClose.emit(true);
  }

  onClickCancel() {
    this.filterClose.emit(true);
  }

  onClickClear() {
    this.value = null;
    this.valueTo = null;
    this.matchMode = this.defaultMatchMode;
    this.saveFilter();
    this.filterClose.emit(true);
  }

  onDateFocusEvent(event: any) {
    if (event.target.type == "datetime-local")
      event.target.type = "text";
  }

  onKeyPressFilterInput(event: KeyboardEvent) {
    if (event.which === Keys.ENTER) {
      this.onClickOk();
    }
    //https://stackoverflow.com/questions/17976393/html5-input-type-number-not-working-in-firefox
    //else {
    //  let char = String.fromCharCode(event.keyCode); // Get the character
    //  if (/^[0-9]*$/.test(char))
    //    return true;
    //  // Match with regex
    //  else event.preventDefault(); // If not match, don't add to input text
    //}
  }

  //onDateFocusOutEvent(event: any) {
  //  if (event.target.type == "text")
  //    event.target.type = "datetime-local";
  //}



  //addEvent(event: any) {
  //  console.log(event.value);
  //  this.filterOpen.emit(true);
  //}
  //public effectiveDateFrom = new Date();
}
